export default {
    modify_collection_item: 'Modify collection item',
    edit_collection_item: 'Edit collection item',
    add_new_collection_item: 'Add new collection item',
    field_name: 'Field name',
    field_type: 'Field type',
    attention_phone_number:
        'Attention!!!!!*****★★★★★: Please select the system-provided name and phone number field types for name and phone number, otherwise the data statistics will be inaccurate! Remember!',
    uploadable_recruitment_types: 'Uploadable recruitment types',
    select_company_collection_item: 'Please select the company collection item',
    house_number_address: 'House number and address',
    postal_code: 'Postal code',
    upload_template_file: 'Upload template file',
    click_to_view_file: 'Click to view file',
    award_configuration: 'Award configuration',
    award_type: 'Award type',
    select_evaluation_type: 'Please select the evaluation type',
    upload_id_card: 'Upload ID card',
    age_limit: 'Limit by age',
    province_limit: 'Limit by province',
    show_yes_no_option: 'Show yes/no option',
    max_age_limit: 'Maximum age limit',
    enter_max_age_limit: 'Please enter the maximum age limit',
    province_restriction: 'Province restriction',
    select_province: 'Please select a province',
    option_content: 'Option content',
    upload_file_format: 'Upload file format',
    system_field_content_not_editable: 'System field content cannot be changed',
    calendar_format: 'Calendar format',
    custom_format: 'Custom format',
    enter_date_type: 'Please enter the date type',
    date_format_example: 'Format: yyyy-MM-dd HH:mm:ss',
    date_value_example: 'Example value: 2023-08-18 20:08:08',
    max_options: 'Maximum number of selectable options',
    no_option_limit: 'Leave this field empty or set it to 0 to not limit the number of selectable options.',
    resume_min_words: 'Minimum number of words for personal resume',
    no_word_limit: 'Leave this field empty or set it to 0 to not limit the number of words! Note: English websites limit by the number of words.',
    resume_max_words: 'Maximum number of words for personal resume',
    this_field_is_required: 'This field is required',
    parent_option_and_display_condition: 'Parent option and display condition',
    parent_option: 'Parent option',
    parent_option_order_note: 'Note: The parent option sorting must be placed before the child fields',
    display_condition: 'Display condition',
    display_field_condition: 'This field will be displayed when the parent option selects this condition',
    enter_display_name: 'Please enter the display name',
    prompt_text: 'Prompt text',
    empty_value_prompt: 'Prompt when the value is empty',
    select_reg: 'Please select the file format for {reg}',
    new_channel: 'Add new channel',
    edit_channel: 'Edit channel',
    general_configuration: 'General configuration',
    channel_id: 'Channel ID',
    enter_channel_id: 'Please enter the category ID',
    show_in_left_menu: 'Show separately in the left menu',
    show: 'Show',
    not_show: 'Hide',
    max_submission_limit: 'Max submissions per person',
    default_no_limit: 'The default value of 0 means no limit',
    manuscript_language: 'Manuscript language',
    collect_other_authors: 'Collect other authors',
    collect_corresponding_author: 'Collect Corresponding Author',
    collect_speaking_author: 'Collect speaking author',
    min_abstract_words: 'Abstract Min Words',
    max_abstract_words: 'Abstract Max Words',
    complete_language_info: 'Please complete at least one language information',
    is_open: 'Is it open?',
    channel_name: 'Channel name',
    submission_instructions: 'Submission instructions',
    show_statement_confirmation: 'Enable statement confirmation',
    statement_confirmation_title: 'Statement confirmation title text',
    statement_confirmation_details: 'Statement confirmation detailed content',
    update_class: 'Update category',
    class_id: 'Category ID',
    parent_class: 'Parent category',
    chinese_name: 'Chinese name',
    english_name: 'English name',
    short_name: 'Abbreviated name',
    supported_channels: 'Supported channels',
    poster_cover_image: 'Poster cover display image',
    image_format_support: 'Supports JPG, GIF, PNG image files. Recommended size: 1080*1920',
    upload_image: 'Upload image',
    please_select_status: 'Please select the status',
    first_category: 'First-level category',
    submission_is_open: 'Is website submission enabled?',
    submission_open: 'Open',
    submission_close: 'Close',
    submission_deadline: 'Submission deadline',
    first_author_restriction: 'First author restriction',
    first_author_must_be_submitter: 'The first author must be the submitter',
    first_author_can_choose: 'The first author can be freely selected',
    max_submissions_per_user: 'Limit the maximum number of submissions per person',
    default_no_limit_hint: 'The default value of 0 means no limit',
    chinese_submit_button_text: 'Chinese submission button text',
    chinese_submit_button_hint: 'Text in the left menu after the front - end representative logs in',
    chinese_custom_url: 'Chinese submission custom link',
    chinese_preview_name: 'Chinese submission preview name',
    chinese_submit_text: 'Chinese submission submit button text',
    english_submit_button_text: 'English submission button text',
    english_custom_url: 'English submission custom link',
    english_preview_name: 'English preview name',
    english_submit_text: 'English submission submit button text',
    link_format_error: 'The link format is incorrect',
    status_open: 'Open',
    status_closed: 'Closed',
    category_name_placeholder: 'Please enter the category name',
    add_channel_button: 'Add channel',
    submission_limit_column: 'Submission limit',
    delete_confirmation: 'Are you sure you want to delete the current category?',
    delete_channel: 'Are you sure you want to delete the current channel?',
    status_update_success: 'Status updated successfully',
    no_limit: 'No limit',
    max_send_num: 'Maximum number of submissions',
    cn_web: 'Chinese website',
    en_web: 'English website',
    channel_config: 'Channel configuration',
    first_author: 'First author',
    other_author: 'Other authors',
    collect_content: 'Thesis collection content',
    upload_collect: 'Upload data collection',
    base_params: {
        title: 'Basic parameters',
        submit: 'Submit',
        reset: 'Reset',
        save_success: 'Saved successfully',
        save_failed: 'Save failed',
        form_title: 'Form title',
        enter_form_title: 'Please enter the form title',
        form_type: 'Form type',
        select_form_type: 'Please select the form type',
        form_status: 'Form status',
        select_form_status: 'Please select the form status',
        form_desc: 'Form description',
        enter_form_desc: 'Please enter the form description',
        form_sort: 'Form sorting',
        enter_form_sort: 'Please enter the form sorting',
        form_required: 'Is it required?',
        form_visible: 'Is it visible?',
        form_editable: 'Is it editable?',
        form_default: 'Default value',
        enter_form_default: 'Please enter the default value',
        form_placeholder: 'Placeholder',
        enter_form_placeholder: 'Please enter the placeholder',
        form_validation: 'Validation rule',
        enter_form_validation: 'Please enter the validation rule',
        form_error_msg: 'Error message',
        enter_form_error_msg: 'Please enter the error message',
        loading: 'Loading...',
        is_open: 'Is website submission enabled?',
        open: 'Open',
        close: 'Close',
        deadline: 'Submission deadline',
        first_author_limit: 'First author restriction',
        first_author_must_be_submitter: 'The first author must be the submitter',
        first_author_can_choose: 'The first author can be freely selected',
        max_submissions: 'Limit the maximum number of submissions per person',
        no_limit_hint: 'The default value of 0 means no limit',
        chinese: 'Chinese',
        english: 'English',
        chinese_submit_button: 'Chinese submission button text',
        chinese_submit_button_hint: 'Text in the left menu after the front - end representative logs in',
        chinese_custom_url: 'Chinese submission custom link',
        chinese_preview_name: 'Chinese submission preview name',
        chinese_submit_text: 'Chinese submission submit button text',
        english_submit_button: 'English submission button text',
        english_custom_url: 'English submission custom link',
        english_preview_name: 'English preview name',
        english_submit_text: 'English submission submit button text',
        please_enter: 'Please enter',
        submit: 'Submit immediately',
        invalid_url: 'The link format is incorrect'
    },
    class_params: {
        select_status: 'Is it enabled?',
        enabled: 'Enabled',
        disabled: 'Disabled',
        enter_class_name: 'Please enter the category name',
        search: 'Search',
        add_class: 'Add category',
        open: 'Open',
        close: 'Close',
        add_sub_class: 'Add sub - category',
        edit: 'Edit',
        delete: 'Delete',
        sort: 'Sort',
        class_name: 'Category name',
        class_name_en: 'English name',
        status: 'Status',
        action: 'Action',
        confirm_title: 'Prompt',
        delete_confirm_msg: 'Are you sure you want to delete the current category?',
        confirm: 'Confirm',
        cancel: 'Cancel',
        delete_success: 'Deleted successfully',
        delete_failed: 'Delete failed',
        status_change_success: 'Status changed successfully'
    },
    channel_params: {
        title: 'Channel parameters',
        add_channel: 'Add new channel',
        edit_channel: 'Edit channel',
        delete_channel: 'Delete channel',
        channel_name: 'Channel name',
        enter_channel_name: 'Please enter the channel name',
        channel_code: 'Channel code',
        enter_channel_code: 'Please enter the channel code',
        channel_sort: 'Channel sorting',
        enter_channel_sort: 'Please enter the channel sorting',
        channel_status: 'Channel status',
        select_channel_status: 'Please select the channel status',
        channel_desc: 'Channel description',
        enter_channel_desc: 'Please enter the channel description',
        confirm_delete: 'Confirm deletion',
        delete_confirm_msg: 'Are you sure you want to delete this channel?',
        delete_success: 'Deleted successfully',
        delete_failed: 'Delete failed',
        save_success: 'Saved successfully',
        save_failed: 'Save failed'
    },
    form_params: {
        title: 'Form parameters',
        add_field: 'Add new field',
        edit_field: 'Edit field',
        delete_field: 'Delete field',
        field_name: 'Field name',
        enter_field_name: 'Please enter the field name',
        field_code: 'Field code',
        enter_field_code: 'Please enter the field code',
        field_type: 'Field type',
        select_field_type: 'Please select the field type',
        field_sort: 'Field sorting',
        enter_field_sort: 'Please enter the field sorting',
        field_status: 'Field status',
        select_field_status: 'Please select the field status',
        field_desc: 'Field description',
        enter_field_desc: 'Please enter the field description',
        field_required: 'Is it required?',
        field_visible: 'Is it visible?',
        field_editable: 'Is it editable?',
        field_default: 'Default value',
        enter_field_default: 'Please enter the default value',
        field_placeholder: 'Placeholder',
        enter_field_placeholder: 'Please enter the placeholder',
        field_validation: 'Validation rule',
        enter_field_validation: 'Please enter the validation rule',
        field_error_msg: 'Error message',
        enter_field_error_msg: 'Please enter the error message',
        confirm_delete: 'Confirm deletion',
        delete_confirm_msg: 'Are you sure you want to delete this field?',
        delete_success: 'Deleted successfully',
        delete_failed: 'Delete failed',
        save_success: 'Saved successfully',
        save_failed: 'Save failed',
        back_to_channel_list: 'Back to channel list',
        loading: 'Loading...',
        system_field_notice: 'Note: Use system fields first, otherwise it will affect the later statistics and data export!',
        selected_form_items: 'Selected form items',
        required: 'Required',
        upload_file: 'Upload file',
        yes: 'Yes',
        no: 'No',
        select_collection_items: 'Select collection items',
        system: 'System',
        edit: 'Edit',
        add_custom_collection_item: 'Add custom collection item'
    },
    payment_params: {
        title: 'Payment parameters',
        payment_type: 'Payment type',
        select_payment_type: 'Please select the payment type',
        payment_name: 'Payment name',
        enter_payment_name: 'Please enter the payment name',
        payment_code: 'Payment code',
        enter_payment_code: 'Please enter the payment code',
        payment_sort: 'Payment sorting',
        enter_payment_sort: 'Please enter the payment sorting',
        payment_status: 'Payment status',
        select_payment_status: 'Please select the payment status',
        payment_desc: 'Payment description',
        enter_payment_desc: 'Please enter the payment description',
        payment_config: 'Payment configuration',
        enter_payment_config: 'Please enter the payment configuration',
        save_success: 'Saved successfully',
        save_failed: 'Save failed',
        loading: 'Loading...',
        enable_payment: 'Enable manuscript payment',
        open: 'Open',
        close: 'Close',
        domestic_currency: 'Domestic payment currency',
        domestic_amount: 'Domestic payment amount',
        foreign_currency: 'Foreign payment currency',
        foreign_amount: 'Foreign payment amount',
        payment_deadline: 'Payment deadline',
        submit: 'Submit immediately'
    },
    abstract_edit: {
        edit_abstract: 'Manuscript editing',
        add_abstract: 'Add new manuscript',
        select_channel: 'Select channel',
        submitter_info: 'Submitter information',
        user_id: 'User ID',
        name: 'Name',
        gender: 'Gender',
        family_name: 'Family name in pinyin',
        given_name: 'Given name in pinyin',
        highest_degree: 'Highest degree',
        technical_title: 'Technical title',
        province: 'Province',
        area: 'Area',
        administrative_position: 'Administrative position',
        workplace: 'Workplace',
        department: 'Department',
        address: 'House number and address',
        postal_code: 'Postal code',
        mobile: 'Mobile phone',
        work_phone: 'Work phone',
        email: 'Email',
        all_orgs: 'All organizations of the paper authors',
        org_name: 'Organization name',
        org_address: 'Organization address',
        org_postal_code: 'Organization postal code',
        action: 'Action',
        add_org: 'Add organization',
        all_authors: 'All author information',
        abstract_content: 'Manuscript content',
        other_settings: 'Other settings',
        submission_status: 'Submission status',
        select_submission_status: 'Please select the submission status',
        completed: 'Completed',
        not_completed: 'Not completed',
        final_acceptance_type: 'Final acceptance type',
        select_acceptance_type: 'Please select the final acceptance type',
        no_acceptance_type: 'No final acceptance type',
        paper_number: 'Paper number',
        enter_paper_number: 'Please enter the paper number',
        show_electronic_poster: 'Show electronic poster',
        select_show_poster: 'Please select whether to show the electronic poster',
        not_show: 'Hide',
        show: 'Show',
        accept: 'Accept?',
        select_accept: 'Please select whether to accept',
        feedback: 'Feedback',
        close: 'Close',
        submit: 'Submit'
    },
    add_author: {
        edit_author: 'Edit author',
        add_author: 'Add new author',
        author_org: "Author's organization",
        select_author_org: "Please select the author's organization",
        corresponding_author: 'Corresponding author',
        speaking_author: 'Speaking author'
    },
    add_org: {
        title: 'Add organization',
        org_name: 'Organization name',
        enter_org_name: 'Please enter the organization name',
        org_address: 'Organization address',
        enter_org_address: 'Please enter the organization address',
        org_postal_code: 'Organization postal code',
        enter_org_postal_code: 'Please enter the organization postal code',
        cancel: 'Cancel',
        submit: 'Submit'
    },
    all_author: {
        all_authors: 'All authors of this paper',
        add_author: 'Add author',
        author_number: 'Author {number}',
        name: 'Name',
        mobile: 'Mobile phone',
        email: 'Email',
        corresponding_author: 'Corresponding author',
        speaking_author: 'Speaking author',
        belonging_org: 'Affiliated organization'
    },
    abstract_audit: {
        title: 'Manuscript review',
        topic_category: 'Topic category',
        abstract: 'Abstract',
        keywords: 'Keywords',
        audit_opinion: 'Review opinion',
        enter_audit_opinion: 'Please enter the review opinion',
        approve: 'Approve',
        reject: 'Reject',
        submit_success: 'Submitted successfully'
    },
    abstract_detail: {
        topic_category: 'Topic category: ',
        abstract: 'Abstract: ',
        keywords: 'Keywords: '
    },
    email_template: {
        title: 'Title',
        enter_title: 'Please enter the title',
        sender_name: 'Sender name',
        enter_sender_name: 'Please enter the sender name',
        email_address: 'Sending/Receiving email',
        enter_email_address: 'Please enter the sending/receiving email',
        email_subject: 'Email subject',
        enter_email_subject: 'Please enter the email subject',
        template_content: 'Template content',
        is_enabled: 'Is it enabled?',
        yes: 'Yes',
        no: 'No',
        close: 'Close',
        submit: 'Submit',
        submit_success: 'Submitted successfully'
    },
    sms_title: 'Title',
    sms_enter_title: 'Please enter the title',
    sms_template_content: 'Template content',
    sms_max_length_tip: 'The maximum number of characters in a single SMS message should not exceed 500 characters.',
    sms_signature: 'SMS signature',
    sms_signature_option1: 'Conference Management System',
    sms_signature_option2: 'Conference Organizing Committee',
    sms_signature_tip:
        'Signature notice: The operator has enabled the global whitelist control function. Currently, 【Conference Management System】 and 【Conference Organizing Committee】 are provided. If you want to use a custom signature, please include it directly in the SMS content.',
    sms_is_enabled: 'Is it enabled?',
    sms_yes: 'Yes',
    sms_no: 'No',
    sms_enabled_tip1: 'Note: If the SMS content contains tags, the number of characters in the SMS content is calculated based on the content after tag replacement!',
    sms_enabled_tip2:
        'SMS billing rule: One charge for up to 70 characters. For more than 70 characters, one charge for every 67 characters. The maximum length of an SMS is 500 characters. Calculated by characters, 1 English letter, 1 number, 1 punctuation mark, 1 space, and 1 Chinese character all count as 1 character. Long SMS is charged in multiples of 67 characters.',
    sms_close: 'Close',
    sms_submit: 'Submit',
    sms_submit_success: 'Submitted successfully',
    email_history_detail: {
        email_content: 'Email content',
        email: 'Email',
        sender: 'Sender',
        send_time: 'Sending time',
        send_status: 'Sending status',
        theme: 'Theme',
        operator_send_status: 'Operator sending status',
        send_return_value: 'Sending return value',
        send_email_record: 'Email sending record',
        enter_email: 'Please enter the email',
        status: 'Status',
        all: 'All',
        not_send: 'Not sent',
        send_success: 'Sent successfully',
        send_failed: 'Sending failed',
        send_processing: 'Sending',
        query: 'Query',
        email_send_record: 'Email sending record',
        email_template_record: 'Sending template record',
        click_to_view: 'Click to view',
        num: 'Number (pieces)',
        operation: 'Operation',
        content: 'Content',
        total_count: 'Total: {totalCount} pieces'
    },
    email_view: {
        modal_title: 'Email content',
        dear_dr: 'Dear Dr.',
        table1_id: 'ID',
        table1_title: 'Manuscript title',
        table1_first_author: 'First author',
        table1_result: 'Review result',
        table1_author: 'Author',
        table1_paper_title: 'Title',
        table1_result_value: 'Result',
        row_paper_number: 'Paper number',
        row_paper_title: 'Paper title',
        row_first_author: 'First author',
        row_all_authors: 'All authors',
        row_review_result: 'Review result',
        row_title: 'Title',
        table2_id: 'ID',
        table2_title: 'Manuscript title',
        table2_first_author: 'First author',
        table2_corresponding_author: 'Corresponding author',
        table2_result: 'Review result',
        table2_paper_title: 'Title',
        table2_first_author_value: 'First author',
        table2_corresponding_author_value: 'Corresponding author',
        table2_result_value: 'Result'
    },
    upload: {
        poster_ppt_cn: 'Chinese poster PPT',
        poster_ppt_en: 'English poster PPT',
        full_text_cn: 'Chinese full - text attachment',
        full_text_en: 'English full - text attachment',
        ppt_cn: 'Chinese PPT',
        ppt_en: 'English PPT',
        abstract_cn: 'Chinese abstract',
        abstract_en: 'English abstract',
        video_url_cn: 'Chinese video',
        video_url_en: 'English video'
    },
    abstract_list: {
        search_paper_id: 'Paper ID',
        search_title: 'Title',
        search_first_author: 'First author',
        search_first_author_org: "First author's organization",
        search_first_author_province: "First author's province",
        search_submitter: 'Submitting author',
        search_payment_status: 'Registration payment status',
        search_payment_status_placeholder: 'Please select the payment status',
        search_payment_status_paid: 'Paid',
        search_payment_status_unpaid: 'Unpaid',
        search_manuscript_status: 'Manuscript status',
        search_manuscript_status_placeholder: 'Please select the manuscript status',
        search_channel: 'Paper channel',
        search_channel_placeholder: 'Please select the paper channel',
        search_class: 'Paper category',
        search_class_placeholder: 'Please select the paper category',
        search_acceptance_type: 'Acceptance type',
        search_acceptance_type_placeholder: 'Please select the acceptance type',
        search_sort: 'Sorting',
        search_sort_placeholder: 'Please select the sorting',
        search_sort_desc: 'Sort by paper ID in descending order',
        search_sort_asc: 'Sort by paper ID in ascending order',
        search_sort_update_time: 'Sort by the last update time',
        search_publish_type: 'Proposed communication type',
        search_publish_type_placeholder: 'Please select the proposed communication type',
        button_search: 'Search',
        button_add: 'Add',
        button_clear: 'Clear',
        button_set_cn_notice: 'Set Chinese acceptance notice letter',
        button_set_en_notice: 'Set English acceptance notice letter',
        button_email_record: 'Email sending record',
        table_paper_id: 'Paper ID',
        table_class: 'Category',
        table_title: 'Title',
        table_first_author: 'First author',
        table_submitter: 'Submitter',
        table_acceptance_type: 'Acceptance type',
        table_channel: 'Channel',
        table_attachment: 'Full - text attachment',
        table_upload_cn_attachment: 'Upload Chinese attachment',
        table_upload_en_attachment: 'Upload English attachment',
        table_ppt: 'PPT',
        table_upload_cn_ppt: 'Upload Chinese PPT',
        table_upload_en_ppt: 'Upload English PPT',
        table_poster: 'Electronic poster',
        table_upload_cn_poster: 'Upload Chinese poster',
        table_upload_en_poster: 'Upload English poster',
        table_notice: 'Paper acceptance notice letter',
        table_preview_email: 'Click to preview email',
        table_send_email: 'Click to send email',
        table_last_update_time: 'Last update time',
        table_action: 'Action',
        table_edit: 'Edit',
        table_delete: 'Delete',
        table_preview: 'Preview',
        table_download_attachment: 'Download attachment',
        delete_confirm_title: '',
        delete_confirm_content: 'Are you sure you want to delete this manuscript?',
        delete_success: 'Deleted successfully',
        attachment_not_exist: 'Attachment does not exist'
    },
    statistics: {
        hire_type: {
            title: 'Acceptance type',
            total: 'Total'
        },
        recommend_org: {
            title: 'Recommended organization',
            total: 'Total'
        },
        type: {
            title: 'Type',
            by_org: 'Statistics by organization',
            by_province: 'Statistics by province',
            view: 'View'
        },
        author: {
            city: {
                title: 'Province',
                total: 'Total'
            },
            country: {
                title: 'Country',
                total: 'Number'
            },
            org: {
                title: 'Organization',
                total: 'Number'
            },
            province: {
                title: 'Province',
                total: 'Number'
            }
        },
        modal: {
            org_title: 'Statistics by organization',
            province_title: 'Statistics by province'
        },
        echarts: {
            type: 'Type',
            class: 'Manuscript category',
            city: "Submitter's province and city",
            country: "First author's country",
            org: "First author's organization",
            province: "First author's province",
            hire_type: 'Acceptance type',
            recommend_org: 'Recommended organization'
        }
    },
    export_params: {
        paper_attachment_download: 'Paper attachment download',
        submission_channel: 'Submission channel',
        select_submission_channel: 'Please select the submission channel',
        submission_category: 'Submission category',
        all: 'All',
        proposed_communication_type: 'Proposed communication type',
        final_communication_type: 'Final communication type',
        data_type: 'Data type',
        paper_id_export: 'Paper IDs to be exported',
        export_by_order: 'Export in this order',
        one_per_line: 'One per line. Leave it blank to export all.',
        export_paper_attachment: 'Paper attachment export',
        submit_success: 'Submitted successfully'
    },
    export_template_params: {
        paper_export: 'Paper manuscript export',
        submission_channel: 'Submission channel',
        select_submission_channel: 'Please select the submission channel',
        submission_category: 'Submission category',
        all: 'All',
        proposed_communication_type: 'Proposed communication type',
        final_communication_type: 'Final communication type',
        has_attachment: 'Has attachment?',
        yes: 'Yes',
        no: 'No',
        template_content: 'Template content includes',
        proposed_type: 'Proposed communication type',
        final_type: 'Final communication type',
        category: 'Category',
        paper_id: 'Paper ID',
        chinese_title: 'Chinese title',
        english_title: 'English title',
        paper_number: 'Paper number',
        author_and_org: 'Author and organization',
        org_province: "Organization's province and city",
        org_postal_code: "Organization's postal code",
        contact_author: 'Corresponding author',
        contact_author_email: "Corresponding author's email",
        abstract: 'Abstract',
        keywords: 'Keywords',
        references: 'References',
        barcode: 'Barcode',
        awards: 'Awards',
        online_review_avg: 'Online review average score',
        online_review_status: 'Online review status',
        first_author_photo: "First author's photo and resume",
        show_review_input: 'Show review result input box',
        word_export_spec: 'Word document export specification',
        merge_one_word: 'Merge into one Word document',
        one_category_one_word: 'One category per Word document',
        one_paper_one_word: 'One paper per Word document',
        paper_number_setting: 'Paper number setting',
        title_setting: 'Title setting',
        author_setting: 'Author setting',
        org_setting: 'Organization setting',
        abstract_setting: 'Abstract setting',
        keywords_setting: 'Keywords setting',
        references_setting: 'References setting',
        title_author_separator: 'Between title and author',
        author_abstract_separator: 'Between author and abstract',
        keywords_abstract_separator: 'Between keywords and previous text',
        reference_abstract_separator: 'Between references and previous text',
        article_two_separator: 'Between two articles',
        paper_sort_rule: 'Paper sorting rule',
        paper_id_export: 'Paper IDs to be exported',
        export_by_order: 'Export in this order',
        one_per_line: 'One per line. Leave it blank to export all. Maximum 4000 IDs can be entered at a time.',
        export_word_format: 'Batch export in Word format'
    }
};
